var _rect, _g, _g2, _g3, _g4, _g5, _g6, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueBackground(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.000244141,
    width: 1920.5,
    height: 1080,
    fill: "url(#paint0_linear_1_8587)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1424.74 798.889C1373.44 790.894 1322.74 779.211 1274.01 763.81L1271.75 770.755L1320.7 783.858L1286.35 912.155L1179.44 883.535L1213.78 755.238L1264.61 768.845L1266.99 761.559C1199.83 739.753 1136.61 710.828 1081 674.709L1085.36 668C1140.32 703.704 1202.91 732.342 1269.46 753.952L1271.94 746.355L1278.95 748.64L1276.49 756.203C1354.87 780.971 1438.52 796.072 1521.54 801.564C1540.7 802.831 1559.81 803.587 1578.81 803.832L1579.08 798.767L1586.45 799.158L1586.2 803.901C1638.2 804.21 1689.28 800.686 1737.95 793.363L1737.74 792.523L1744.92 790.793L1745.26 792.23C1818.58 780.563 1886.19 760.188 1942.9 731.227L1946.54 738.352C1889.15 767.661 1820.95 788.233 1747.14 800.031L1749.19 808.53L1801.73 797.234L1829.65 927.082L1721.44 950.345L1693.53 820.498L1741.98 810.081L1739.83 801.169C1690.38 808.65 1638.51 812.23 1585.77 811.898L1585.22 822.384L1635.89 822.372L1635.92 955.186L1525.24 955.212L1525.21 822.398L1577.83 822.386L1578.39 811.826C1559.34 811.575 1540.2 810.815 1521.02 809.547C1491.36 807.585 1461.61 804.404 1432.03 800.001L1429.73 813.037L1480.75 823.354L1454.42 953.533L1345.94 931.595L1372.26 801.416L1422.5 811.574L1424.74 798.889Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1536.61,
    y: 833.128,
    width: 88.5427,
    height: 88.5427,
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1222.02,
    y: 768.555,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(14.9863 1222.02 768.555)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1706.93,
    y: 828.593,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(-12.1333 1706.93 828.593)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1381.31,
    y: 814.196,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(11.4323 1381.31 814.196)",
    fill: "#7386FF"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M333.105 807.203C281.203 806.109 229.393 801.282 179.052 792.506L177.735 799.69L227.99 806.159L211.035 937.886L101.262 923.757L118.218 792.03L170.406 798.747L171.788 791.21C102.33 778.54 35.8141 758.291 -24.1067 729.898L-20.681 722.669C38.5506 750.735 104.395 770.785 173.23 783.341L174.67 775.483L181.928 776.813L180.494 784.637C261.474 798.748 346.393 802.575 429.405 796.964C448.558 795.669 467.602 793.873 486.466 791.586L486.058 786.53L493.413 785.937L493.795 790.671C545.377 784.053 595.533 773.759 642.789 760.021L642.476 759.216L649.355 756.546L649.89 757.924C721.003 736.598 785.295 707.403 837.644 671.149L842.199 677.726C789.221 714.415 724.368 743.885 652.793 765.405L655.957 773.555L706.524 755.365L751.48 880.339L647.335 917.803L602.379 792.829L649.011 776.054L645.694 767.507C597.68 781.506 546.753 791.96 494.439 798.654L495.283 809.12L545.5 802.361L563.216 933.989L453.527 948.752L435.81 817.125L487.96 810.106L487.11 799.566C468.202 801.853 449.123 803.649 429.944 804.946C400.292 806.95 370.384 807.759 340.484 807.333L339.938 820.56L391.874 823.992L383.117 956.517L272.679 949.22L281.436 816.695L332.573 820.074L333.105 807.203Z",
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 448.544,
    y: 826.24,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(-7.66557 448.544 826.24)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.157,
    y: 804.131,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(7.33443 128.157 804.131)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 616.742,
    y: 799.067,
    width: 88.5428,
    height: 88.5428,
    transform: "rotate(-19.7851 616.742 799.067)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.107,
    y: 828.155,
    width: 88.5427,
    height: 88.5427,
    transform: "rotate(3.78045 292.107 828.155)",
    fill: "#7386FF"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1438.56 548.789C1344.9 525.976 1256.04 490.291 1181 441.548L1185.9 434C1259.96 482.101 1347.82 517.413 1440.59 540.02L1441.82 534.692L1449.75 536.522L1448.5 541.915C1505.66 555.359 1564.57 564.01 1623.16 567.887C1624.78 567.994 1626.4 568.097 1628.02 568.197L1629.05 558.366L1637.15 559.22L1636.15 568.668C1693.55 571.778 1750.44 570.293 1804.85 564.263L1804.17 560.6L1812.17 559.106L1812.96 563.329C1899.72 552.944 1979.91 530.9 2045.53 497.392L2049.62 505.407C1983.06 539.396 1902.05 561.675 1814.61 572.194L1815.86 578.888L1874.38 569.464L1897.67 714.087L1777.15 733.496L1753.86 588.873L1807.83 580.182L1806.51 573.134C1751.18 579.304 1693.41 580.807 1635.2 577.63L1634.46 584.731L1690.27 587.628L1682.67 733.918L1560.77 727.591L1568.36 581.301L1626.32 584.309L1627.07 577.156C1625.57 577.063 1624.07 576.966 1622.57 576.867C1563.55 572.963 1504.16 564.249 1446.48 550.684L1444.57 558.93L1500.17 573.223L1463.7 715.097L1345.47 684.704L1381.95 542.83L1436.69 556.903L1438.56 548.789Z",
    fill: "#B9D3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1580.3,
    y: 593.774,
    width: 97.6578,
    height: 97.6578,
    transform: "rotate(2.97079 1580.3 593.774)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1768.16,
    y: 598.56,
    width: 97.6578,
    height: 97.6578,
    transform: "rotate(-9.14878 1768.16 598.56)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1391.18,
    y: 557.426,
    width: 97.6578,
    height: 97.6578,
    transform: "rotate(14.4168 1391.18 557.426)",
    fill: "#7386FF"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M532.058 534.789C625.719 511.976 714.579 476.291 789.621 427.548L784.719 420C710.665 468.101 622.8 503.413 530.034 526.02L528.804 520.692L520.874 522.522L522.119 527.915C464.965 541.359 406.056 550.01 347.459 553.887C345.841 553.994 344.223 554.097 342.605 554.197L341.568 544.366L333.474 545.22L334.471 554.668C277.067 557.778 220.184 556.293 165.767 550.263L166.451 546.6L158.451 545.106L157.663 549.329C70.8981 538.944 -9.2901 516.9 -74.9069 483.392L-79.0001 491.407C-12.4432 525.396 68.5757 547.675 156.007 558.194L154.758 564.888L96.2404 555.464L72.9492 700.087L193.468 719.496L216.76 574.873L162.795 566.182L164.111 559.134C219.437 565.304 277.21 566.807 335.417 563.63L336.166 570.731L280.356 573.628L287.948 719.918L409.856 713.591L402.264 567.301L344.305 570.309L343.55 563.156C345.051 563.063 346.552 562.966 348.053 562.867C407.072 558.963 466.465 550.249 524.143 536.684L526.047 544.93L470.447 559.223L506.919 701.097L625.147 670.704L588.675 528.83L533.931 542.903L532.058 534.789Z",
    fill: "#B9D3FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.6578,
    height: 97.6578,
    transform: "matrix(-0.998656 0.0518269 0.0518269 0.998656 390.317 579.774)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.6578,
    height: 97.6578,
    transform: "matrix(-0.987279 -0.158999 -0.158999 0.987279 202.46 584.56)",
    fill: "#7386FF"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 97.6578,
    height: 97.6578,
    transform: "matrix(-0.96851 0.248974 0.248974 0.96851 579.441 543.426)",
    fill: "#7386FF"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2012.32 268.581C1897.86 264.099 1779.89 249.855 1663.66 220.724L1665.35 213.098L1647.18 209.076L1645.63 216.081C1418.74 156.081 1199.51 38.1519 1027.13 -176L1017 -167.848C1191.64 49.1061 1413.65 168.27 1642.82 228.779L1638.51 248.245L1535.1 227.076L1481.06 491.047L1701.04 536.076L1755.07 272.104L1656.75 251.977L1660.86 233.417C1778.03 262.752 1896.8 277.068 2011.81 281.571L2012.32 268.581Z",
    fill: "#BBD7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1552.59,
    y: 253.576,
    width: 179.63,
    height: 179.63,
    transform: "rotate(11.5685 1552.59 253.576)",
    fill: "#5B9AFF"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-62.2674 238.039C46.832 251.166 164.411 245.412 282.894 203.748L278.883 192.959L296.326 186.475L300.367 197.344C423.502 150.361 547.21 63.736 663.001 -81.6126L673.169 -73.5124C555.784 73.8371 430.102 161.786 304.897 209.529L308.962 220.462L408.042 189.52L488.362 446.715L274.033 513.649L193.712 256.454L291.173 226.018L287.424 215.934C166.909 258.35 47.215 264.306 -63.8204 250.946L-62.2674 238.039Z",
    fill: "#BBD7FF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.839,
    y: 271.193,
    width: 179.63,
    height: 179.63,
    transform: "rotate(-17.3433 221.839 271.193)",
    fill: "#5B9AFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_8587",
    x1: 960.25,
    y1: 0,
    x2: 960.25,
    y2: 1080,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#18C6E4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A9AAFF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueBackground);
export default __webpack_public_path__ + "static/media/BlueBackground.27e3b06bf5b6fe0489b9.svg";
export { ForwardRef as ReactComponent };